var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.128906,
    width: 16,
    height: 16,
    rx: 6,
    fill: "url(#paint0_linear_428_55968)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.75C7.35721 4.75 6.72886 4.94061 6.1944 5.29772C5.65994 5.65484 5.24338 6.16242 4.99739 6.75628C4.75141 7.35014 4.68705 8.00361 4.81245 8.63404C4.93785 9.26448 5.24738 9.84358 5.7019 10.2981C6.15643 10.7526 6.73552 11.0622 7.36596 11.1876C7.9964 11.313 8.64986 11.2486 9.24372 11.0026C9.83758 10.7566 10.3452 10.3401 10.7023 9.8056C11.0594 9.27114 11.25 8.64279 11.25 8C11.2483 7.13855 10.9054 6.31286 10.2963 5.70373C9.68714 5.09459 8.86145 4.75165 8 4.75ZM9.75 8.25H8C7.9337 8.25 7.87011 8.22366 7.82322 8.17678C7.77634 8.12989 7.75 8.0663 7.75 8V6.25C7.75 6.1837 7.77634 6.12011 7.82322 6.07322C7.87011 6.02634 7.9337 6 8 6C8.06631 6 8.12989 6.02634 8.17678 6.07322C8.22366 6.12011 8.25 6.1837 8.25 6.25V7.75H9.75C9.81631 7.75 9.87989 7.77634 9.92678 7.82322C9.97366 7.87011 10 7.9337 10 8C10 8.0663 9.97366 8.12989 9.92678 8.17678C9.87989 8.22366 9.81631 8.25 9.75 8.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_428_55968",
    x1: -2.21696,
    y1: -10.623,
    x2: 24.2018,
    y2: -5.90685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27C69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C7BDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.02424afb6c9e288c0a22aec618252b93.svg";
export { ForwardRef as ReactComponent };